<template>
  <v-select
    v-model="model"
    dense
    outlined
    item-text="descricao"
    return-object
    :placeholder="placeholder"
    :label="label"
    :rules="[rules.required]"
    :items="items.filter(item => item.descricao === 'Interurbano')"
    :disabled="disabled"
    multiple
  />
</template>

<script>
import enderecoService from '@/services/sit-pedidos/pedido.service'

export default {
  name: 'AtuationAreaSelect',

  props: {
    label: {
      type: String,
      required: true,
    },

    placeholder: {
      type: String,
      required: true,
    },

    value: {
      type: Array,
      default: ()=>([]),
    },

    disabled: {
      type: Boolean,
      default: ()=>(false),
    }
  },

  data: () => ({
    items: [],

    rules: {
      required: value => !!value || "Esse campo deve ser preenchido"
    }
  }),

  computed: {
    model: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },

  mounted(){
    this.load()
  },

  methods: {
    load() {
      enderecoService.atuationAreasList().subscribe((res)=>{
        this.items = res
      })
    }
  }
}
</script>
